/**
 * An enum specifying the different types of search that can be conducted
 * through the SearchService.
 */
export enum SearchType {
  DEFAULT,
  METADATA,
  FULLTEXT,
  TV,
  RADIO,
  FEDERATED,
}
